// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"259561f3954cbb44220d","532":"cac64a08314cee954b19","678":"b40184daf3c42b131c4c","883":"ed114e18235735a9d3d2"}[chunkId] + ".js";
};